/* Touch swiping for every horizontal strip (product photos, reviews, video cards).
   Native scroll-snap stays as the base. On touch screens this also drives the scroll by hand,
   so swiping works the same on every phone, vertical page scrolling stays free, and the strip
   snaps to the nearest card when the finger lifts. */
(() => {
  if (window.__spongeSwipe) return;
  window.__spongeSwipe = true;
  const bound = new WeakSet();

  const bind = (track) => {
    if (bound.has(track)) return;
    bound.add(track);
    let sx = 0, sy = 0, sl = 0, mode = null;
    track.style.touchAction = 'pan-y';

    track.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) { mode = 'ignore'; return; }
      const t = e.touches[0];
      sx = t.clientX; sy = t.clientY; sl = track.scrollLeft; mode = null;
      track.style.scrollSnapType = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      if (mode === 'ignore' || mode === 'y') return;
      const t = e.touches[0];
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (mode === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        mode = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (mode === 'x') {
        track.scrollLeft = sl - dx;
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    const end = () => {
      track.style.scrollSnapType = '';
      const swiped = mode === 'x';
      mode = null;
      if (!swiped) return;
      const base = track.getBoundingClientRect().left;
      let best = null, bd = Infinity;
      [...track.children].forEach((c) => {
        const d = Math.abs(c.getBoundingClientRect().left - base);
        if (d < bd) { bd = d; best = c; }
      });
      if (best) track.scrollTo({ left: track.scrollLeft + (best.getBoundingClientRect().left - base), behavior: 'smooth' });
    };
    track.addEventListener('touchend', end);
    track.addEventListener('touchcancel', end);
  };

  const scan = () => document.querySelectorAll('[data-gallery-track], [data-track]').forEach(bind);
  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();
